import { createSlice } from "@reduxjs/toolkit";
import { ThunkHttpClient } from "../../utils/httpThunkClient";

export const saveOrUpdateHotelData = ThunkHttpClient.post('master/saveOrUpdateHotelData', 
    (data) => ({ url: "master/saveOrUpdateHotelData", body: data }));
export const updateHotelDataStatus = ThunkHttpClient.get('master/updateHotelDataStatus', 
    (data) => `master/updateHotelDataStatus?id=${data.id}&status=${data.status}`);
export const getAllHotels = ThunkHttpClient.get('master/getAllHotelData', (status) => `master/fetchAllHotelDetails?status=${status}`);

export const hotelMasterSlice = createSlice({
    name: 'hotelMaster',
    initialState: {
        hotelsData: [],
        loading: false
    },
    reducers: {

    },
    extraReducers: (builder) => {
        
        // save or update hotel data
        builder.addCase(saveOrUpdateHotelData.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(saveOrUpdateHotelData.rejected, (state) => {
            state.loading = false;
        });
        builder.addCase(saveOrUpdateHotelData.fulfilled, (state, action) => {
            state.loading = false;
        });

        // Get All Hotels
        builder.addCase(getAllHotels.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getAllHotels.fulfilled, (state, action) => {
            state.loading = false;
            state.hotelsData = action.payload.data;
        });
        builder.addCase(getAllHotels.rejected, (state) => {
            state.loading = false;
        });

        // update hotel data status]
        builder.addCase(updateHotelDataStatus.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(updateHotelDataStatus.rejected, (state) => {
            state.loading = false;
        });
        builder.addCase(updateHotelDataStatus.fulfilled, (state, action) => {
            state.loading = false;
        });
    }
})

export default hotelMasterSlice.reducer;
